import _ from 'lodash';
import { IActiveLayer, IActiveLayerAction, IActiveLayerReducerState } from '../activeLayerTypes';
import { ILayer } from '../../layers/layerTypes';

export function setActiveLayer (state: IActiveLayerReducerState,
    action: IActiveLayerAction) {
    const idx = state.findIndex(layer => layer.uid === action.activeLayer.uid);
    if (idx === -1) {
        return [...state, { ...action.activeLayer, pinned: true }];
    } else {
        state.splice(idx, 1, {
            // Removes problem of filters resetting when layers are toggled
            // sourceLayer: state[idx].sourceLayer,
            ...action.activeLayer
        });
        return [...state];
    }
}

export function setActiveLayers (state: IActiveLayerReducerState,
    action: IActiveLayerAction) {
    const newState = [...state];
    for (let i = 0; i < action.activeLayers.length; i++) {
        const idx = newState.findIndex(l => l.uid === action.activeLayers[i].uid);
        const layer = action.layers ? action.layers.find((l: {system_name:string}) => l.system_name === action.activeLayers[i].systemName) : null;
        if (idx !== -1) {
            const aLayer = { ...newState[idx] };
            newState.splice(idx, 1, {
                sourceLayer: layer.sourceLayer,
                ...action.activeLayers[i]
            });
        } else {
            newState.push({
                sourceLayer: action.activeLayers[i].sourceLayer,
                ...action.activeLayers[i]
            });
        }
    }
    return newState;
}

export const setActiveLayerStyling = (activeLayers: IActiveLayer[], uid:string, layer:IActiveLayer) => {
    const activeLayerIndex = activeLayers.findIndex(l => l.uid === uid);
    return [
        ...activeLayers.splice(activeLayerIndex, 1, {
            ...activeLayers[activeLayerIndex]
        })
    ];
};